export default __webpack_public_path__ + "static/blogThumbnail(5)-935adcdb8ea2c4b3bda57b8f36b77ef6.png";